<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-30 16:01:08
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-06-15 18:06:02
 * @Description: 处理意见
-->
<template>
  <div>
    <div class="list" v-if="list && list.length > 0">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div
          class="inner"
          :class="`logType-${item.logType} resultType-${item.resultType}`"
        >
          <div :class="`index index-${index}`"></div>
          <div class="time">
            <div>
              <span class="userName">{{ item.userName }}</span>
              <span class="taskName" v-if="item.taskName">
                [{{ item.taskName }}]</span
              >
            </div>
            <div>
              <el-button
                type="danger"
                @click="() => taskReminder(item)"
                :disabled="!item.remindable"
                style="margin-right: 8px"
                v-if="item.remindEnabled && item.logType === '000'"
                :loading="loading"
                >催办</el-button
              >
              <span class="logType" v-if="item.logType === '000'">未处理</span>
              {{ item.time }}
            </div>
          </div>
          <div class="result">{{ item.resultName }}</div>
          <div class="message" v-if="item.message">
            批注：{{ item.message || "-" }}
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="list && list.length === 0">暂无信息</div>
  </div>
</template>

<script>
export default {
  props: {
    businessKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      isMobile: document.body.clientWidth <= 800,
    };
  },
  created() {
    this.comments();
  },
  methods: {
    // 催办
    taskReminder(item) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const obj = {
        businessKey: item.businessKey,
        taskDefinitionKey: item.taskKey,
        params: { _noLoading: true }
      };
      this.$http
        .post("/help/workflow/auth/v1/ru-tasks/task-reminder", obj)
        .then(({ data: res }) => {
          this.loading = false;
          if (res.code === 0) {
            this.$message.success("催办成功");
            this.comments();
          }
        });
    },
    comments() {
      this.$http
        .get(`/help/workflow/auth/v2/acte-hi-oplogs/${this.businessKey}`, {
          params: { _noLoading: true }
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = res.data;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  position: relative;
  max-height: 450px;
  overflow: auto;
  padding-left: 10px;
  margin-left: -10px;

  .logType {
    font-size: 14px;
    color: #262727;
    line-height: 20px;
  }

  .item {
    padding: 0 0 16px 18px;
    border-left: 1px solid #d9d9d9;
    .index {
      position: absolute;
      left: -26px;
      top: 18px;
      width: 12px;
      height: 12px;
      background: linear-gradient(132deg, #5eb3f0 0%, #0079ff 100%);
      border-radius: 50%;
    }
    .inner {
      position: relative;
      padding: 12px;
      color: #1d65a8;
      border: 1px solid transparent;
      box-shadow: 0px 2px 5px 0px rgba(190, 208, 230, 0.5);
      border-radius: 6px;
      max-width: 98%;
      &.logType-000 {
        box-shadow: 0px 2px 5px 0px rgba(217, 236, 255, 0.5);
        border-color: #bed0e6;
        .index {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          left: -29px;
          background: rgba(46, 136, 255, 0.37);
          &::after {
            display: block;
            width: 12px;
            height: 12px;
            background: #ffffff;
            border: 1px solid #2e88ff;
            border-radius: 50%;
            content: " ";
          }
        }
      }
      &.logType-101 {
        box-shadow: 0px 2px 5px 0px rgba(225, 243, 216, 0.5);
        border-color: #e1f3d8;
        .index {
          background: linear-gradient(180deg, #a0e36c 0%, #67c23a 100%);
        }
        .userName {
          color: #67c23a;
        }
      }
      &.resultType-2,
      &.logType-100,
      &.logType-103,
      &.logType-104 {
        box-shadow: 0px 2px 5px 0px #fde2e2;
        border-color: #fde2e2;
        .index {
          background: linear-gradient(180deg, #fba5a5 0%, #f56c6c 100%);
        }
        .userName {
          color: #f56c6c;
        }
      }
    }
  }
  .time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999;
    font-size: 12px;
    line-height: 21.5px;
    .userName {
      font-size: 16px;
      color: #262727;
    }
    .taskName {
      font-size: 14px;
      color: #666666;
    }
  }
  .result {
    padding-top: 7px;
    font-size: 14px;
    color: #2e88ff;
    line-height: 20px;
  }
  .message {
    padding-top: 12px;
    margin-top: 12px;
    white-space: pre-line;
    border-top: 1px solid #d9d9d9;
    font-size: 14px;
    color: #666666;
  }
}
</style>
